import { Button, Grid, Typography } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';

import { getLocalizedContent as l } from '@helpers/languages';
import content from './PaymentCompleteInfo.json';
import { getLanguagePrefix } from '@helpers';

export const PaymentCompleteInfo = ({ info }) => {
  const { prefixLanguage } = useSelector(({ appState }) => appState);
  const language = prefixLanguage || 'en';

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant="h5">{l(content.checkEmail, language)}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body2">{info}</Typography>
      </Grid>
      <Grid item xs={12} sm={8}>
        <Button
          onClick={() =>
            window.location.assign(
              `${window.location.origin}${getLanguagePrefix(
                language
              )}/portal/designs`
            )
          }
          fullWidth
          data-go-to-my-account
        >
          {l(content.gotoAccount, language)}
        </Button>
      </Grid>
    </Grid>
  );
};
